/* ============================================================
   Sunrise Atelier — motion layer (GSAP + ScrollTrigger)
   Loaded before global.js; sets MOTION_ACTIVE so the older
   IntersectionObserver reveal stands down and nothing double-animates.
   ============================================================ */
window.MOTION_ACTIVE = true;

(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    document.documentElement.classList.add('motion-off');
    document.querySelectorAll('video[autoplay]').forEach(function (v) { try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {} });
    return;
  }
  if (typeof gsap === 'undefined') { document.documentElement.classList.add('motion-off'); return; }

  gsap.registerPlugin(ScrollTrigger);
  document.documentElement.classList.add('motion-on');

  var EASE = 'power3.out';
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- split a heading into word masks so it can rise in ---------- */
  function splitWords(el) {
    if (!el || el.dataset.split) return [];
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var spans = words.map(function (w, i) {
      var mask = document.createElement('span');
      mask.className = 'w-mask';
      var inner = document.createElement('span');
      inner.className = 'w-in';
      inner.textContent = w;
      mask.appendChild(inner);
      el.appendChild(mask);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      return inner;
    });
    el.dataset.split = '1';
    return spans;
  }


  /* ---------- safe reveal ----------
     gsap.from() hides a target the moment it is called and only restores it if
     its trigger fires. Anything already on screen, or any trigger that loses a
     race with a fast scroll, is then stuck invisible. So: only pre-hide targets
     that are actually below the fold, animate those, and leave everything else
     exactly as CSS rendered it. ------------------------------------------------ */
  var VH = function () { return window.innerHeight || 800; };
  function reveal(targets, from, to, trigger, stagger) {
    targets = (targets || []).filter(Boolean);
    if (!targets.length) return;
    var below = targets.filter(function (el) { return el.getBoundingClientRect().top > VH() * 0.92; });
    if (!below.length) return;                       // on screen already: never touch it
    gsap.set(below, from);
    gsap.to(below, Object.assign({}, to, {
      stagger: stagger || 0,
      scrollTrigger: { trigger: trigger || below[0], start: 'top 96%', once: true }
    }));
  }

  /* ================= HERO — entrance ================= */
  function hero() {
    var h = $('.hero--split');
    if (!h) return;
    var media = $('.hero__media img', h);
    var head  = $('.hero__inner h1', h);
    var words = splitWords(head);
    var tl = gsap.timeline({ defaults: { ease: EASE } });

    if (media) {
      gsap.set(media, { scale: 1.14, transformOrigin: '50% 50%' });
      tl.to(media, { scale: 1, duration: 2.0, ease: 'power2.out' }, 0);
      tl.fromTo(h.querySelector('.hero__media'),
        { clipPath: 'inset(0% 0% 100% 0%)' },
        { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.25, ease: 'power3.inOut' }, 0);
    }
    tl.from($('.hero__inner .eyebrow', h), { y: 18, opacity: 0, duration: .7 }, .25);
    if (words.length) tl.from(words, { yPercent: 118, duration: .95, stagger: .075 }, .32);
    else tl.from(head, { y: 30, opacity: 0, duration: .9 }, .32);
    tl.from($('.hero__inner p', h),        { y: 22, opacity: 0, duration: .8 }, .62);
    tl.from($$('.hero__actions .btn', h),  { y: 20, opacity: 0, duration: .7, stagger: .1 }, .74);
    tl.from($$('.hero__facts > div', h),   { y: 18, opacity: 0, duration: .7, stagger: .09 }, .9);
    tl.from($('.hero__facts', h),          { scaleX: 0, transformOrigin: 'left', duration: .8 }, .86);

    /* gentle parallax as the hero leaves */
    if (media) {
      gsap.to(media, {
        yPercent: 9, ease: 'none',
        scrollTrigger: { trigger: h, start: 'top top', end: 'bottom top', scrub: 0.6 }
      });
    }
  }

  /* ================= generic section reveal ================= */
  function reveals() {
    $$('.section-head').forEach(function (el) {
      var kids = $$(':scope > *', el);
      reveal(kids.length ? kids : [el], { y: 30, opacity: 0 },
             { y: 0, opacity: 1, duration: .85, ease: EASE }, el, .08);
    });

    [['.editorial-grid', '.editorial-tile', 56, .1],
     ['.cat-grid',       '.cat-tile',       48, .09],
     ['.division-grid',  '.division-card',  56, .12],
     ['.feature-grid',   '.feature-card',   46, .09],
     ['.product-grid',   '.card',           36, .04],
     ['.loc-grid',       '.loc-tile',       46, .08]
    ].forEach(function (cfg) {
      $$(cfg[0]).forEach(function (grid) {
        reveal($$(cfg[1], grid), { y: cfg[2], opacity: 0 },
               { y: 0, opacity: 1, duration: .9, ease: EASE }, grid, cfg[3]);
      });
    });

    /* Horizontal offsets widen the document on narrow screens, so only slide
       sideways where there is room; otherwise rise vertically. */
    var wide = window.innerWidth >= 991;
    $$('.story-grid').forEach(function (g) {
      var fromA = wide ? { x: -38, opacity: 0 } : { y: 30, opacity: 0 };
      var fromB = wide ? { x:  38, opacity: 0 } : { y: 30, opacity: 0 };
      var to    = { x: 0, y: 0, opacity: 1, duration: 1.0, ease: EASE };
      reveal([$('.story-media', g)], fromA, to, g);
      reveal([$('.story-copy', g) || $('.stack', g)], fromB, to, g);
    });

    $$('.prose > *').forEach(function (el) {
      reveal([el], { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: .7, ease: EASE }, el);
    });
  }

  /* ================= image parallax inside fixed frames ================= */
  function parallax() {
    $$('.editorial-tile__media img, .division-card__media img, .cat-tile img, .feature-card__media img')
      .forEach(function (img) {
        gsap.fromTo(img, { yPercent: -6 }, {
          yPercent: 6, ease: 'none',
          scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: 0.8 }
        });
      });

    /* full-bleed banners drift slightly slower than the page */
    $$('.promo-banner__media img, .page-hero__media img').forEach(function (img) {
      gsap.fromTo(img, { yPercent: -8 }, {
        yPercent: 8, ease: 'none',
        scrollTrigger: { trigger: img.closest('section') || img.parentElement,
                         start: 'top bottom', end: 'bottom top', scrub: 0.8 }
      });
    });
  }

  /* ================= number counters ================= */
  function counters() {
    $$('.hero__facts dt, .stat .figure, .map-stats .figure').forEach(function (el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
      if (!m) return;
      var prefix = m[1], numStr = m[2].replace(/,/g, ''), suffix = m[3];
      var target = parseFloat(numStr);
      if (!isFinite(target)) return;
      var decimals = (numStr.split('.')[1] || '').length;
      var grouped = m[2].indexOf(',') > -1;
      var obj = { v: 0 };
      gsap.to(obj, {
        v: target, duration: 1.5, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 97%', once: true },
        onUpdate: function () {
          var n = decimals ? obj.v.toFixed(decimals) : Math.round(obj.v).toString();
          if (grouped) n = Number(n).toLocaleString('en-US');
          el.textContent = prefix + n + suffix;
        }
      });
    });
  }

  /* ================= product page ================= */
  function product() {
    var gal = $('.product-gallery'), info = $('.product-info');
    if (gal)  gsap.fromTo(gal,  { y: 26, opacity: 0 }, { y: 0, opacity: 1, duration: .9, ease: EASE });
    if (info) gsap.fromTo($$(':scope > *', info), { y: 20, opacity: 0 },
                          { y: 0, opacity: 1, duration: .8, ease: EASE, stagger: .07, delay: .12 });
  }

  /* ================= safety net =================
     A gsap.from() leaves its target at the start state until the trigger fires.
     If a visitor scrolls faster than the triggers resolve, content can sit at
     opacity 0 forever. Sweep anything that is in view or already scrolled past
     and still invisible, and hand it back to CSS. Content beats choreography. */
  function safetyNet() {
    $$('.section-head > *, .editorial-tile, .cat-tile, .division-card, .feature-card, .card, .loc-tile, .story-media, .story-copy, .prose > *, .hero__facts > div, .hero__actions .btn, .product-gallery, .product-info > *')
      .forEach(function (el) {
        var r = el.getBoundingClientRect();
        var seen = r.top < window.innerHeight * 1.15;   // in view or already passed
        if (!seen) return;
        if (parseFloat(getComputedStyle(el).opacity) < 0.9) {
          gsap.killTweensOf(el);
          gsap.set(el, { clearProps: 'opacity,transform,clipPath' });
        }
      });
  }
  /* Throttle, not debounce. A debounce keeps resetting while the visitor is
     still scrolling, so during a long fast flick it never runs at all — which
     is exactly the case that strands content. Run during the scroll, and once
     more after it settles. */
  var sweepTimer, lastSweep = 0, sweepQueued = false;
  function scheduleSweep() {
    var now = Date.now();
    if (now - lastSweep > 120 && !sweepQueued) {
      sweepQueued = true;
      requestAnimationFrame(function () { sweepQueued = false; lastSweep = Date.now(); safetyNet(); });
    }
    clearTimeout(sweepTimer);
    sweepTimer = setTimeout(safetyNet, 200);   // trailing pass once scrolling stops
  }

  function init() {
    /* the hero is above the fold and its markup is ready now */
    hero(); product();

    /* Everything else must be measured AFTER images have laid out, or the page is
       still short, every section looks "above the fold", and nothing gets hidden
       to animate. Anything the visitor has already scrolled to stays untouched. */
    var started = false;
    var startScroll = function () {
      if (started) return; started = true;
      reveals(); parallax(); counters();
      ScrollTrigger.refresh();
      scheduleSweep();
    };
    if (document.readyState === 'complete') startScroll();
    else window.addEventListener('load', startScroll);
    setTimeout(startScroll, 3000);   // don't wait forever on a slow asset

    ScrollTrigger.refresh();
    window.addEventListener('scroll', scheduleSweep, { passive: true });
    window.addEventListener('resize', scheduleSweep);
    window.addEventListener('load', function () { ScrollTrigger.refresh(); scheduleSweep(); });
    setTimeout(safetyNet, 2000);
    /* last resort: after 5s nothing may remain hidden, anywhere on the page */
    setTimeout(function () {
      $$('[style*="opacity"]').forEach(function (el) {
        if (parseFloat(getComputedStyle(el).opacity) < 0.9 && !gsap.isTweening(el)) {
          gsap.set(el, { clearProps: 'opacity,transform,clipPath' });
        }
      });
    }, 5000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
